import { z } from "zod";
export const healthDataSchema = z.object({
    service: z.literal("icraftx-api"),
    version: z.literal("v1"),
    status: z.literal("ok"),
    databaseConfigured: z.boolean().optional(),
});
